import React, { useContext } from "react";
import { Badge } from "@chakra-ui/react";
import { BadgeGroupItemContext } from "./badge-group-item-context";
export function DestinationBadge(props) {
    const { isHidden } = useContext(BadgeGroupItemContext);
    return (React.createElement(Badge, { variant: "destination", "aria-hidden": isHidden ? "true" : undefined, ...props }));
}
